<div [class]="this.styles">
  <div class="w-full">
    <p>{{ text | translate }}</p>
  </div>
  <a3l-ui-progress-bar class="my-5 w-full" [value]="this.analyzingDataLoadingTime"></a3l-ui-progress-bar>
</div>
